import { getRefreshToken, getAccessToken, setTokens, clearTokens } from './tokenService';
import axios from "axios";
import objeler from "../objeler";

export const refreshAccessToken = async () => {
    const refreshToken = getRefreshToken();
    const oldAccessToken = getAccessToken();
    const url = window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/refresh/';
    // axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/Logout', null
// console.log('oldAccessToken',oldAccessToken);
// console.log('refreshToken',refreshToken);
    const formData = new FormData();
    formData.append("accessToken", oldAccessToken);

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${refreshToken}`

        },
        body: formData
    });
// console.log('response',response)
    if (!response.ok) {
        clearTokens();
        throw new Error('Refresh failed');
    }

    // const data = await response.text();
    const data = await response.json();
    // console.log('DATA',data)
    setTokens({
        accessToken: data.AccessToken,
        refreshToken: data.RefreshToken,
    });

    return data.access_token;
};
